import { useState, useEffect, useContext, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import HospitalCustomPaginaion from "../../../utils/HospitalPaginationUtil";
import { logOut } from "../../../config/user";
import { fetchCommentCount } from "../../../redux/notificationSlice";
import { CircularProgress } from "@mui/material";
import { CommentServices } from "../../../services/CommentServices";
import { AuthServices } from "../../../services/AuthServices";
import { PreinitiateServices } from "../../../services/PreinitiateServices";
import CloseIcon from "../../../assets/hospitalCloseIcon.svg";
import DownloadIcon from "../../../assets/downloadIconGreen.svg";
import RotateLeft from "../../../assets/rotate-left.svg";
import RotateRight from "../../../assets/rotate-right.svg";
import Crop from "../../../assets/crop.svg";
import RightArrow from "../../../assets/rightArrowWhite.svg";
import SpeakerIcon from "../../../assets/speakerIcon.svg";
import CcChatCheck from "../../../assets/CcChatCheck.svg";
import ReuploadImageIcon from "../../../assets/reUploadImageIcon.png";
import CallIcon from "../../../assets/call filled.svg";
import SendIcon from "../../../assets/sendIcon.svg";
import RiskIcon from "../../../assets/riskIcon.svg";
import HighRiskText from "../../../assets/HighRiskText.svg";
import SpeechToText from "../../../assets/speechToText.svg";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { docUploadRefreshContext } from "../../../dashboard/cases/contexts/CaseContexts";

import html2canvas from "html2canvas";
import { getUser } from "../../../config/user";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { useSelector, useDispatch } from "react-redux";
import { CaseServices } from "../../../services/CaseServices";
import { Close } from "@mui/icons-material";
import { useFormikContext } from "formik";
const ImageGalleryScreenshot = ({
  data,
  setData,
  setOpen,
  setIsScreenshotOpen,
  selectedImage,
  view,
  type,
  getDocumentsData,
  documentId,
  index,
}) => {
  const [imageState, setImageState] = useState({
    image: "",
    brightness: 100,
    grayscale: 0,
    sepia: 0,
    saturate: 100,
    contrast: 100,
    hueRotate: 0,
    rotate: 0,
    vertical: 1,
    horizontal: 1,
  });
  const [selectedFilter, setSelectedFilter] = useState({
    name: "",
    maxValue: "",
  });
  const [crop, setCrop] = useState(null);
  const [details, setDetails] = useState(null);
  const [docDetails, setDocDetails] = useState(null);
  const [riskData, setRiskData] = useState(null);
  const [openRiskModal, setOpenRiskModal] = useState(false);
  const [users, setUsers] = useState(null);
  const [message, setMessage] = useState("");
  const [ccChecked, setCcChecked] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reUploading, setReuploading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(
    selectedImage ? selectedImage : 1
  );
  const [currentCommentId, setCurrentCommentId] = useState(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(-1);
  const [startId, setStartId] = useState(null);
  const [endId, setEndId] = useState(null);
  const { setFieldValue } = useFormikContext();
  const chatContainerRef = useRef();
  const dispatch = useDispatch();
  const endOfMessagesRef = useRef(null);
  const { messageId } = useSelector((store) => store.notificationReducer);
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  // const referenceContext = useContext(docUploadRefreshContext);
  const reUploadFileRef = useRef();
  const handleReUploadButtonClick = () => {
    reUploadFileRef.current.click();
  };
  const handleSelect = (i) => {
    if (startId === null) {
      setStartId(i);
    } else if (endId === null) {
      setEndId(i);
    } else {
      // reset selection if clicked third time
      setStartId(i);
      setEndId(null);
    }
  };
  // Convert base64 to File
  const base64ToFile = (base64, filename) => {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  const takeScreenshot = async () => {
    setLoading(true);
    if (!chatContainerRef.current || startId === null || endId === null) {
      alert("Please select start and end messages");
      setLoading(false);
      return;
    }

    const allMessages = Array.from(
      chatContainerRef.current.querySelectorAll(".chat-msg")
    );

    const startIndex = Math.min(startId, endId);
    const endIndex = Math.max(startId, endId);

    const selectedMessages = allMessages.slice(startIndex, endIndex + 1);

    // clone selected messages into temp container
    const container = document.createElement("div");
    container.style.padding = "10px";
    container.style.background = "white";
    container.style.width = chatContainerRef.current.offsetWidth + "px";

    selectedMessages.forEach((msg) => {
      const clone = msg.cloneNode(true);
      clone.classList.remove("bg-green-100", "bg-green-50");
      clone.classList.remove(
        "outline",
        "outline-2",
        "outline-1",
        "outline-green-600",
        "outline-green-400",
        "outline-dashed"
      );
      container.appendChild(clone);
    });

    document.body.appendChild(container);
    const canvas = await html2canvas(container, { scale: 2 });
    document.body.removeChild(container);

    const imgData = canvas.toDataURL("image/png");
    const file = base64ToFile(imgData, "chat-screenshot.png");
    // const link = document.createElement("a");
    // link.href = imgData;
    // link.download = "chat-selection.png";
    // link.click();
    try {
      let data = new FormData();
      data.append("image", file);
      let res = await AuthServices.uploadImage(data); // Upload to S3
      window.alert("Image uploaded successfully");
      setFieldValue(
        `caseProcedures.${index}.procedureApprovalUrl`,
        res?.data?.url
      );
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setStartId(null);
    setEndId(null);

    setIsScreenshotOpen(false);
    setOpen(-1);
    setLoading(false);
  };
  const user = getUser();
  const filterValue = [
    {
      name: "brightness",
      maxValue: "200",
    },
    {
      name: "grayscale",
      maxValue: "200",
    },
    {
      name: "sepia",
      maxValue: "200",
    },
    {
      name: "saturate",
      maxValue: "200",
    },
    {
      name: "contrast",
      maxValue: "200",
    },
    {
      name: "hueRotate",
      maxValue: "200",
    },
  ];
  const defaultRisks = async () => {
    try {
      const res = await CommentServices.getDefaultRisks();
      setRiskData(res?.data?.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const reUploadImage = async (e) => {
    setReuploading(true);
    try {
      let formData = new FormData();
      formData.append("image", e.target.files[0]);
      let res = await AuthServices.uploadImage(formData);
      data[currentIndex - 1].documentUrl = res?.data?.url;
      type === "document"
        ? await CaseServices.saveDocumentUrl(documentId, [
            {
              ...data[currentIndex - 1],
              documentUrl: res?.data?.url,
              urlId: data[currentIndex - 1].id,
            },
          ])
        : await PreinitiateServices.updateReferenceDocument(
            {
              documentUrl: res?.data?.url,
            },
            selectedDoc.id
          );

      window.alert("Image uploaded successfully");
      await getDocumentsData();
      // setReuploadedDocUrl(res?.data?.url);
    } catch (error) {
      if (error?.response?.status === 401) {
        logOut();
      } else {
        handleApiErrorResponses(error);
      }
    }
    setReuploading(false);
  };
  const getUsers = async () => {
    try {
      const res = await CommentServices.getAllUserDetail();
      setUsers(res?.data?.users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDocComments = async () => {
    try {
      const res = await CommentServices.getDocumentComments(
        type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
        data[currentIndex - 1].id
      );
      setDocDetails(res?.data?.documentDetails);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCommentAdd = async () => {
    if (message) {
      try {
        const commentData = {
          documentId: data[currentIndex - 1].id,
          message: message,

          commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
        };
        const res = await CommentServices.sendComment(commentData);
        setMessage("");
        // await referenceContext.getMappedDocuments();
        await getDocComments();
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }
  };
  const handleRiskCommentAdd = async (riskData) => {
    try {
      const commentData = {
        documentId: data[currentIndex - 1].id,
        message: riskData.message,
        riskResponse: riskData?.riskResponse,
        riskType: riskData?.riskType,
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      };
      const res = await CommentServices.sendComment(commentData);
      setOpenRiskModal(false);
      await getDocComments();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCodeCommentAdd = async (message) => {
    try {
      const commentData = {
        documentId: data[currentIndex - 1].id,
        message: message,
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      };
      const res = await CommentServices.sendComment(commentData);
      setOpenRiskModal(false);
      await getDocComments();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCallButtonClick = async () => {
    const text = `Welcome to Settlemed!
Thank you for reaching out. Your call request has been received.
We appreciate your patience—our Command Centre team will get back to you shortly via the Settlemed mobile application.

If you haven’t downloaded the app yet, please do so to stay connected and ensure smooth communication.`;

    try {
      const commentData = {
        documentId: data[currentIndex - 1].id,
        message: "Kindly give me a call back at your earliest convenience",
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      };
      await CommentServices.sendComment(commentData);

      await getDocComments();

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-US";
      utterance.rate = 1.5;

      window.speechSynthesis.speak(utterance);
      window.alert(text);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleCCfilter = async () => {
    if (ccChecked) {
      setCcChecked(false);
      await getDocComments();
    } else {
      const filteredComments = docDetails.comments?.filter(
        (comment) =>
          !users[comment.from].role?.toLowerCase()?.includes("hospital")
      );
      docDetails.comments = filteredComments;
      setDocDetails({ ...docDetails });
      setCcChecked(true);
    }
  };
  const markReadNotification = async () => {
    try {
      await CommentServices.markNotificationReadByDocId(
        data[currentIndex - 1].id
      );
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const updateViewDetail = async () => {
    try {
      const res = await CommentServices.updateViewDetail({
        documentId: data[currentIndex - 1].id,
        commentOn: type === "document" ? "CASEDOCUMENT" : "REFERENCEDOCUMENT",
      });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  // const handleSpeak = (text) => {
  //   if (text !== "") {
  //     const utterance = new SpeechSynthesisUtterance(text);
  //     window.speechSynthesis.speak(utterance);
  //   }
  // };

  const handleSpeak = (text, commentId) => {
    if (!window.speechSynthesis) {
      alert("Speech Synthesis not supported in your browser");
      return;
    }

    // Cancel any ongoing speech
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1;

    const words = text.split(/\s+/); // Split by any whitespace
    setCurrentCommentId(commentId);
    setCurrentWordIndex(-1); // Reset word index
    utterance.onboundary = (event) => {
      if (event.name === "word") {
        const charIndex = event.charIndex;
        let currentCharCount = 0;

        for (let i = 0; i < words.length; i++) {
          // Add word length plus space (except last word)
          currentCharCount += words[i].length + (i < words.length - 1 ? 1 : 0);

          if (charIndex < currentCharCount) {
            setCurrentWordIndex(i);
            break;
          }
        }
      }
    };

    utterance.onend = () => {
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    utterance.onerror = (event) => {
      console.error("SpeechSynthesis error:", event);
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    window.speechSynthesis.speak(utterance);
  };

  const stopSpeaking = () => {
    window.speechSynthesis.cancel();
    setCurrentWordIndex(-1);
    setCurrentCommentId(null);
  };

  // Clean up on component unmount
  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
    };
  }, []);

  const getFormattedDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Convert to 12-hour format with AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Hour '0' should be '12'

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };
  const imageCrop = () => {
    const canvas = document.createElement("canvas");
    const scaleX = details.naturalWidth / details.width;
    const scaleY = details.naturalHeight / details.height;
    canvas.width = crop.width;
    canvas.height = canvas.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      details,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
    canvas.toBlob((blob) => {
      if (blob) {
        // Create a Blob URL and set it to state
        const blobUrl = URL.createObjectURL(blob);
        data[currentIndex - 1].documentUrl = blobUrl;
        setData([...data]);
      }
    });
  };
  const applyFilter = () => {
    const canvas = document.createElement("canvas");

    // const img = document.getElementById("image"); // Access your image element

    // Set canvas dimensions to match the image
    canvas.width = details?.naturalWidth;
    canvas.height = details?.naturalHeight;
    const ctx = canvas.getContext("2d");

    // Apply the filter  by modifying the canvas context
    ctx.filter = `brightness(${imageState.brightness}%) sepia(${imageState.sepia}%) saturate(${imageState.saturate}%) contrast(${imageState.contrast}%) grayscale(${imageState.grayscale}%) hue-rotate(${imageState.hueRotate}deg)`;
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((imageState.rotate * Math.PI) / 180);
    ctx.scale(imageState.vertical, imageState.horizontal);

    // Draw the image onto the canvas
    ctx.drawImage(
      details,
      -canvas.width / 2,
      -canvas.height / 2,
      canvas.width,
      canvas.height
    );
    // Convert the canvas to a Blob
    canvas.toBlob((blob) => {
      if (blob) {
        // Create a Blob URL and set it to state
        const blobUrl = URL.createObjectURL(blob);
        data[currentIndex - 1].documentUrl = blobUrl;
        setData([...data]);
      }
    });
    window.alert("Image Modified");
    setOpen(false);
  };
  const handleNextClick = () => {
    if (currentIndex < data.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  const handlePrevClick = () => {
    if (currentIndex > 1) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "ArrowRight") {
      handleNextClick();
    } else if (event.key === "ArrowLeft") {
      handlePrevClick();
    }
  };
  useEffect(() => {
    if (view) {
      getUsers();
      getDocComments();
      markReadNotification();
      dispatch(fetchCommentCount());
      defaultRisks();
    }
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  // useEffect(() => {
  //   if (SpeechRecognition) {
  //     const recognition = new SpeechRecognition();
  //     recognition.continuous = true; // Keep listening until stopped
  //     recognition.interimResults = true; // Show interim results

  //     recognition.onresult = (event) => {
  //       let currentTranscript = "";
  //       for (let i = event.resultIndex; i < event.results.length; i++) {
  //         currentTranscript += event.results[i][0].transcript;
  //       }
  //       setTranscript(currentTranscript);
  //     };

  //     recognition.onerror = (event) => {
  //       console.error("Speech recognition error", event.error);
  //     };

  //     // Start/Stop Listening
  //     if (isListening) {
  //       recognition.start();
  //     } else {
  //       recognition.stop();
  //     }

  //     // Cleanup on component unmount
  //     return () => recognition.stop();
  //   } else {
  //     alert("Speech Recognition API not supported in this browser.");
  //   }
  // }, [isListening]);
  useEffect(() => {
    if (view) {
      getDocComments();
      markReadNotification();
      dispatch(fetchCommentCount());
    }
  }, [currentIndex, messageId]);
  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
    if (view) {
      updateViewDetail();
    }
  }, [docDetails]);
  console.log("Comment data:", docDetails);
  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-[#017C5780] z-[1201]">
      <div className="relative bg-white rounded-[16px] w-[80%] 2xl:w-[70%] h-[80%] p-4 xl:p-8">
        <div className="absolute flex items-center gap-2 top-0 right-0  cursor-pointer">
          <a
            href={data[currentIndex - 1]?.documentUrl}
            download
            className="cursor-pointer"
          >
            <img src={DownloadIcon} alt="download-icon" />
          </a>
          <img
            src={CloseIcon}
            // height={30}
            // width={30}
            alt="close-icon"
            onClick={async () => {
              setOpen(-1);
              view && (await getDocumentsData());
            }}
          />
        </div>

        <div className="text-black flex justify-center h-[90%] mt-2">
          {!view && (
            <div className="w-[40%]">
              <div className="text-[28px] 2xl:text-[33px] -tracking-[7%] mb-1 px-2">
                Document Preview
              </div>
              <div
                style={{ borderTop: "1px solid #E8E8E8", marginBlock: "25px" }}
              />{" "}
              <div className="flex  flex-wrap  h-[30%] w-full  p-1">
                {filterValue?.map((filter, idx) => {
                  return (
                    <div
                      key={idx}
                      className="w-full flex justify-between items-center"
                    >
                      <label className="w-[20%] text-[13px] 2xl:text-[15px] text-[#0B0B0B] -tracking-[5%] capitalize">
                        {filter.name}
                      </label>
                      <input
                        type="range"
                        name={filter.name}
                        value={imageState[filter.name]}
                        max={filter?.maxValue}
                        onChange={(e) =>
                          setImageState({
                            ...imageState,
                            [e.target.name]: e.target.value,
                          })
                        }
                        className="w-[80%] accent-[#017C71]"
                      />
                    </div>
                  );
                })}
              </div>
              {selectedFilter?.name && (
                <div className="flex items-center justify-between mt-2 px-2">
                  {" "}
                  <label className="text-black capitalize">
                    {selectedFilter.name}
                  </label>
                  <input
                    type="range"
                    name={selectedFilter.name}
                    value={imageState[selectedFilter.name]}
                    max={selectedFilter?.maxValue}
                    onChange={(e) =>
                      setImageState({
                        ...imageState,
                        [e.target.name]: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              <div
                style={{ borderTop: "1px solid #E8E8E8", marginBlock: "25px" }}
              />
              <div className="w-[130px] text-[13px] 2xl:text-[15px] -tracking-[5%] capitalize">
                <div className="flex justify-between items-center">
                  <div>Rotate left</div>
                  <img
                    src={RotateLeft}
                    alt="rotate-left"
                    onClick={() =>
                      setImageState({
                        ...imageState,
                        rotate: imageState.rotate - 90,
                      })
                    }
                  />
                </div>
                <div className="flex justify-between items-center mt-7">
                  <div>Rotate right</div>
                  <img
                    src={RotateRight}
                    alt="rotate-right"
                    onClick={() =>
                      setImageState({
                        ...imageState,
                        rotate: imageState.rotate + 90,
                      })
                    }
                  />
                </div>
                {/* <div className="flex justify-between items-center mt-7">
                <div>Crop</div>
                <img
                  src={Crop}
                  alt="crop"
                  onClick={() => {
                    crop ? imageCrop() : window.alert("Select Region To Crop");
                  }}
                />
              </div> */}
              </div>
              <div
                className="w-fit flex items-center gap-5 text-xs 2xl:text-sm text-white bg-[#017C71] leading-[21.7px] -tracking-[3%] mt-10 px-5 2xl:px-6 py-3 2xl:py-4 rounded-full cursor-pointer"
                onClick={applyFilter}
              >
                Save{" "}
                <img src={RightArrow} alt="right-arrow" onClick={applyFilter} />
              </div>
            </div>
          )}
          <div className="h-full w-[70%] flex justify-center ">
            {/* <ReactCrop
              style={{
                height: "100%",
                width: "70%",
                border: "1px solid #E4E4E4",
                overflowY: "scroll",
              }}
              crop={crop}
              onChange={(c) => setCrop(c)}
            >
              <div className="h-auto w-auto flex justify-center items-center ">
                <img
                  src={data[currentIndex]?.documentUrl}
                  onLoad={(e) => setDetails(e.currentTarget)}
                  id="image"
                  style={{
                    filter: `brightness(${imageState.brightness}%) sepia(${imageState.sepia}%) saturate(${imageState.saturate}%) contrast(${imageState.contrast}%) grayscale(${imageState.grayscale}%) hue-rotate(${imageState.hueRotate}deg)`,
                    transform: `rotate(${imageState.rotate}deg)`,
                    maxWidth: "100%", // Constrain the width to the container size
                    maxHeight: "100%", // Constrain the height to the container size
                  }}
                  className="object-contain h-full w-full shadow-2xl rounded-[8px]"
                  alt="document-img"
                />{" "}
              </div>
            </ReactCrop> */}
            <div className="relative h-auto w-auto flex justify-center items-center ">
              <img
                src={data[currentIndex - 1]?.documentUrl}
                onLoad={(e) => setDetails(e.currentTarget)}
                id="image"
                style={{
                  filter: `brightness(${imageState.brightness}%) sepia(${imageState.sepia}%) saturate(${imageState.saturate}%) contrast(${imageState.contrast}%) grayscale(${imageState.grayscale}%) hue-rotate(${imageState.hueRotate}deg)`,
                  transform: `rotate(${imageState.rotate}deg)`,
                  maxWidth: "100%", // Constrain the width to the container size
                  maxHeight: "100%", // Constrain the height to the container size
                }}
                className="object-contain h-full w-full shadow-2xl rounded-[8px]"
                alt="document-img"
              />{" "}
              {data[currentIndex - 1]?.status === "REJECTED" && (
                <div className="absolute h-[100%] w-[100%] top-0 left-0 flex items-center justify-center bg-[#FFD6DB80] rounded-[15px]">
                  {reUploading ? (
                    <CircularProgress />
                  ) : (
                    <img
                      src={ReuploadImageIcon}
                      alt="re-upload-image"
                      className="cursor-pointer"
                      onClick={() => {
                        handleReUploadButtonClick();
                        setSelectedDoc(data[currentIndex - 1]);
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          {view && (
            <div
              style={{ border: "1px solid #F0F0F0", boxSizing: "border-box" }}
              className="relative h-full rounded-[30px] w-[80%] 2xl:w-[50%] p-2"
            >
              <div
                style={{ boxSizing: "border-box" }}
                className="absolute top-0 left-0 w-full bg-white flex justify-between items-center px-[10px] py-[16px] mb-2 rounded-t-[30px] z-1"
              >
                <div className="text-[24px] text-[#191919] font-medium">
                  Chat box ({docDetails && (docDetails?.comments?.length || 0)})
                </div>
                <div className="flex  items-center gap-[10px] mr-5">
                  {/*                   
                  <input type="checkbox" onClick={handleCCfilter} />
                  <div className="text-[#017C71]">CC Chat</div> */}
                  <img
                    src={CallIcon}
                    alt="call-icon"
                    className="cursor-pointer"
                    onClick={handleCallButtonClick}
                  />
                </div>
              </div>
              <div
                ref={chatContainerRef}
                className="h-[72%] 2xl:h-[82%] flex flex-col  overflow-y-scroll mt-12 "
              >
                {docDetails &&
                  docDetails?.comments?.map((comment, idx) => {
                    const isStart = idx === startId;
                    const isEnd = idx === endId;
                    const inRange =
                      startId !== null &&
                      endId !== null &&
                      idx > Math.min(startId, endId) &&
                      idx < Math.max(startId, endId);
                    return (
                      <div
                        key={idx}
                        className={`chat-msg cursor-pointer p-1 rounded-md transition-colors
        ${
          isStart || isEnd
            ? "bg-green-100 outline outline-2 outline-green-600"
            : ""
        }
        ${
          inRange
            ? "bg-green-50 outline outline-1 outline-dashed outline-green-400"
            : ""
        }`}
                        onClick={() => handleSelect(idx)}
                      >
                        {users &&
                        users[comment.from]?.role
                          ?.toLowerCase()
                          .includes("hospital") ? (
                          <div key={idx} className="flex justify-end mt-[10px]">
                            <div className="max-w-[87%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#dcf8c6] rounded-[20px]">
                              <div className="flex items-center justify-between">
                                <div className="flex flex-row-reverse items-center gap-[10px]">
                                  <div className="w-[33px] h-[33px] flex justify-center items-center text-[#0B0B0B] text-[20px] bg-white rounded-full">
                                    {users && users[comment?.from].fullName
                                      ? users[comment?.from].fullName[0]
                                      : "U"}
                                  </div>
                                  <div className="text-[15px] font-medium">
                                    {users && users[comment?.from].fullName
                                      ? users[comment?.from].fullName
                                      : "Unknown"}
                                  </div>
                                </div>
                                <div className="flex items-center gap-[20px] px-[10px]">
                                  <div className="text-[10px] text-[#969696]">
                                    {getFormattedDate(comment.createdAt)}
                                    <DoneAllOutlinedIcon
                                      style={{
                                        color:
                                          comment?.views?.length >=
                                          comment?.to?.length
                                            ? "#00ccff"
                                            : "",
                                        fontSize: "14px",
                                        marginLeft: "8px",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <img
                                      src={SpeakerIcon}
                                      alt="speaker-icon"
                                      className="cursor-pointer w-4 h-4"
                                      onClick={() =>
                                        handleSpeak(comment.message, idx)
                                      }
                                      onKeyDown={(e) =>
                                        e.key === "Enter" &&
                                        handleSpeak(comment.message, idx)
                                      }
                                      role="button"
                                      tabIndex={0}
                                    />
                                  </div>
                                </div>
                              </div>
                              {comment?.riskType ? (
                                <div className="flex gap-2 items-start  mt-3">
                                  <div className="w-[40%]">
                                    <img
                                      src={HighRiskText}
                                      alt="high-risk-text-icon"
                                      className="w-full h-auto object-contain"
                                    />
                                  </div>
                                  <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px]">
                                    {comment?.message.split(/\s+/).map(
                                      (
                                        word,
                                        wordIdx // Changed to split(/\s+/) and renamed idx to wordIdx
                                      ) => (
                                        <span
                                          key={wordIdx}
                                          style={{
                                            backgroundColor:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "yellow"
                                                : "transparent",
                                            transition:
                                              "background-color 0.2s ease", // Added smooth transition
                                            marginRight: "4px",
                                            borderRadius:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "4px"
                                                : "0",
                                            padding:
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "0 2px"
                                                : "0",
                                          }}
                                          aria-live={
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "polite"
                                              : "off"
                                          }
                                        >
                                          {word}
                                        </span>
                                      )
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px] mt-3">
                                  {comment?.message.split(/\s+/).map(
                                    (
                                      word,
                                      wordIdx // Changed to split(/\s+/) and renamed idx to wordIdx
                                    ) => (
                                      <span
                                        key={wordIdx}
                                        style={{
                                          backgroundColor:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "yellow"
                                              : "transparent",
                                          transition:
                                            "background-color 0.2s ease", // Added smooth transition
                                          marginRight: "4px",
                                          borderRadius:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "4px"
                                              : "0",
                                          padding:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "0 2px"
                                              : "0",
                                        }}
                                        aria-live={
                                          currentCommentId === idx &&
                                          wordIdx === currentWordIndex
                                            ? "polite"
                                            : "off"
                                        }
                                      >
                                        {word}
                                      </span>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-start mt-[10px]">
                            <div className="max-w-[90%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#F4F4F4] rounded-[20px]">
                              <div className=" flex items-center justify-between">
                                <div className="flex items-center  gap-[10px] ">
                                  <div className="w-[33px] h-[33px]  flex justify-center items-center uppercase text-white text-[20px] bg-[#8B8B8B] rounded-full">
                                    {users && users[comment?.from].userName
                                      ? users[comment?.from].userName[0]
                                      : "U"}
                                  </div>
                                  <div className="text-[15px] font-medium ">
                                    {users && users[comment?.from].userName
                                      ? users[comment?.from].userName
                                      : "Unknown"}
                                  </div>
                                  {users &&
                                    !users[comment.from]?.role
                                      ?.toLowerCase()
                                      .includes("hospital") && (
                                      <div className="text-[10px] text-white px-2 py-1 rounded-full bg-[#017C71]">
                                        CC
                                      </div>
                                    )}
                                </div>
                                <div>
                                  <div className="flex items-center justify-between px-[10px]">
                                    <div className="text-[10px] text-[#969696]">
                                      {getFormattedDate(comment.createdAt)}
                                    </div>
                                    <div>
                                      <img
                                        src={SpeakerIcon}
                                        alt="speaker-icon"
                                        className="cursor-pointer"
                                        onClick={() =>
                                          handleSpeak(comment.message, idx)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {comment?.riskType ? (
                                <div>
                                  <div className="flex gap-2 items-start  mt-3">
                                    <div className="w-[40%]">
                                      <img
                                        src={HighRiskText}
                                        alt="high-risk-text-icon"
                                        className="w-full h-auto object-contain"
                                      />
                                    </div>
                                    <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px]">
                                      {comment?.message.split(/\s+/).map(
                                        (
                                          word,
                                          wordIdx // Changed to split(/\s+/) and renamed idx to wordIdx
                                        ) => (
                                          <span
                                            key={wordIdx}
                                            style={{
                                              backgroundColor:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "yellow"
                                                  : "transparent",
                                              transition:
                                                "background-color 0.2s ease", // Added smooth transition
                                              marginRight: "4px",
                                              borderRadius:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "4px"
                                                  : "0",
                                              padding:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "0 2px"
                                                  : "0",
                                            }}
                                            aria-live={
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "polite"
                                                : "off"
                                            }
                                          >
                                            {word}
                                          </span>
                                        )
                                      )}
                                    </div>
                                  </div>
                                  {/* buttons */}
                                  <div className="flex justify-center items-center gap-3 text-[10px]">
                                    <div
                                      className="uppercase bg-[#017C57] text-white px-5 py-2 rounded-full"
                                      onClick={() =>
                                        handleCodeCommentAdd(
                                          "PLEASE PROCEED WITH EXISTING CODE"
                                        )
                                      }
                                    >
                                      Proceed with existing code
                                    </div>
                                    <div
                                      className="uppercase bg-[#017C57] text-white px-5 py-2 rounded-full"
                                      onClick={() =>
                                        handleCodeCommentAdd(
                                          "PLEASE GET BEST SUITABLE CODE"
                                        )
                                      }
                                    >
                                      GET BEST SUITABLE CODE
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px] mt-3">
                                  {comment?.message.split(/\s+/).map(
                                    (
                                      word,
                                      wordIdx // Changed to split(/\s+/) and renamed idx to wordIdx
                                    ) => (
                                      <span
                                        key={wordIdx}
                                        style={{
                                          backgroundColor:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "yellow"
                                              : "transparent",
                                          transition:
                                            "background-color 0.2s ease", // Added smooth transition
                                          marginRight: "4px",
                                          borderRadius:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "4px"
                                              : "0",
                                          padding:
                                            currentCommentId === idx &&
                                            wordIdx === currentWordIndex
                                              ? "0 2px"
                                              : "0",
                                        }}
                                        aria-live={
                                          currentCommentId === idx &&
                                          wordIdx === currentWordIndex
                                            ? "polite"
                                            : "off"
                                        }
                                      >
                                        {word}
                                      </span>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        <div ref={endOfMessagesRef} />
                      </div>
                    );
                  })}
              </div>
              {/* <div className="absolute bottom-1 left-0 w-full flex justify-center bg-white z-1 bg-transparent rounded-full">
                <div
                  style={{
                    border: "1px solid #EAEAEA",
                    boxSizing: "border-box",
                  }}
                  className="w-[98%] mx-auto flex items-center justify-between p-1 rounded-full bg-white"
                >
                  <textarea
                    placeholder="Type a message..."
                    className="w-[80%] text-[#555] font-semibold outline-none border-none ml-2 resize-none overflow-auto max-h-[300px] bg-transparent"
                    value={message}
                    rows={1}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey && message.trim()) {
                        e.preventDefault(); // Prevents newline on Enter without Shift
                        handleCommentAdd();
                      }
                    }}
                  />
                  <div className="flex items-center gap-1">
                    <img
                      src={RiskIcon}
                      alt="risk-icon"
                      height={32}
                      width={36}
                      onClick={() => setOpenRiskModal(true)}
                      className="cursor-pointer"
                    />
                    <img
                      src={SpeechToText}
                      alt="speech-to-text-icon"
                      onClick={() => setIsListening(!isListening)}
                    />
                    <img
                      src={SendIcon}
                      alt="send-icon"
                      onClick={handleCommentAdd}
                    />
                  </div>
                </div>
              </div> */}
              {openRiskModal && (
                <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center bg-[#017C5780] rounded-[30px]">
                  <div className="relative w-[95%] py-5  bg-[#FFFFFF80] rounded-[30px]">
                    <div
                      className="absolute top-1 right-2 cursor-pointer"
                      onClick={() => setOpenRiskModal(false)}
                    >
                      <Close />
                    </div>
                    <div className="p-[10px]">
                      {riskData &&
                        riskData?.map((risk, idx) => {
                          return (
                            <div
                              key={idx}
                              className="flex items-center gap-2 bg-white px-1 py-2 rounded-[8px] mb-2"
                              onClick={() => handleRiskCommentAdd(risk)}
                            >
                              <div>
                                <img
                                  src={HighRiskText}
                                  alt="high-risk-text-icon"
                                />
                              </div>
                              <div className="text-xs">{risk?.message}</div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className={`flex ${view ? "justify-center" : "justify-end"} mt-5`}>
          <div className="w-[60%] flex justify-center ">
            <HospitalCustomPaginaion
              page={currentIndex}
              setPage={setCurrentIndex}
              totalPages={data.length}
            />
          </div>
          {loading ? (
            <CircularProgress />
          ) : (
            <button
              type="button"
              disabled={loading}
              onClick={takeScreenshot}
              className="mt-2 px-4 py-2 border-0 bg-[#017C71] text-white rounded-lg"
            >
              Capture Selected Range
            </button>
          )}
        </div>
      </div>
      <input
        type="file"
        onChange={(e) => reUploadImage(e)}
        style={{ display: "none" }}
        ref={reUploadFileRef}
        accept=".jpg,.jpeg,.png,"
      />
    </div>
  );
};

export default ImageGalleryScreenshot;
